<template>
    <section v-html="body">
    </section>
</template>

<script>
	import * as CONST from '../../utils/constants';

	export default {
		data: function () {
			return {
				body: CONST.globalProject.Body.Body,
			}
		}
    }
</script>